import { useMemo } from 'react'
import { useParams, useRouteMatch } from 'react-router-dom'

import { CanvasFocus } from './types'
import { deriveCanvasFocus } from './deriveCanvasFocus'

/**
 * Which entity - if any - the current route focuses the canvas on.
 *
 * Called above `CanvasScopeProvider` rather than read from it, because the page
 * handed to the scope depends on the focus: the Share frame route has to look
 * its page up from the frame, and a Preview falls back to its first page. Both
 * hosts hit that ordering, so both call this and pass the result down.
 */
export function useCanvasFocus(): CanvasFocus {
  const { path } = useRouteMatch()
  const { frameUUID, sectionUUID } = useParams<{
    frameUUID?: string
    sectionUUID?: string
  }>()

  // Memoised on the route alone: the focus is handed to `CanvasScopeProvider`,
  // whose value everything under the canvas reads, so a fresh object per render
  // would churn the whole subtree.
  return useMemo(
    () => deriveCanvasFocus(path, { frameUUID, sectionUUID }),
    [path, frameUUID, sectionUUID]
  )
}
